import {Model} from '@vuex-orm/core';
import Dua from './Dua';
import UnitPlanActivity from "./UnitPlanActivity";

export default class UnitPlanActivityDua extends Model {
    static entity = 'unitplan_activity_duas';

    static fields () {
        return {
            id: this.number(0),
            dua_id: this.number(null),
            activity_id: this.number(null),
            disabled: this.boolean(false),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),

            activity: this.belongsTo(UnitPlanActivity, 'activity_id'),
            dua: this.hasOne(Dua, 'id'),
        };
    }
}
